import { render, staticRenderFns } from "./SectionReview.vue?vue&type=template&id=5b2d6a7c&scoped=true&"
import script from "./SectionReview.vue?vue&type=script&lang=js&"
export * from "./SectionReview.vue?vue&type=script&lang=js&"
import style0 from "./SectionReview.vue?vue&type=style&index=0&id=5b2d6a7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2d6a7c",
  null
  
)

export default component.exports